import { Flex, Typography } from "antd"
import cls from "classname"

import Icon from "../../../../Icon"

import "./SourceSelect.less"

const { Text } = Typography

const options = [
  {
    label: "Social media",
    value: "social_media",
    icon: "heart"
  },
  {
    label: "App marketplace (Stripe/Shopify)",
    value: "app_marketplace",
    icon: "store"
  },
  {
    label: "AI tools",
    value: "ai_tools",
    icon: "magic_stick"
  },
  {
    label: "Search engine (Google, Bing, etc)",
    value: "search_engine",
    icon: "search_find_us_form"
  },
  {
    label: "Through a friend",
    value: "through_friend",
    icon: "fistbump"
  },
  {
    label: "Email or newsletter",
    value: "email_newsletter",
    icon: "newspaper"
  },
  {
    label: "Partner course or community",
    value: "partner_program",
    icon: "bookmark_check"
  },
  {
    label: "Award shows or events ",
    value: "events",
    icon: "trophy"
  },
  {
    label: "Industry recommendation",
    value: "industry_recommendation",
    icon: "settings_gear"
  },
  {
    label: "Other",
    value: "other",
    icon: "globe"
  }
]

const SourceSelect = ({ value, onChange }) => {
  const onOptionSelect = (option) => {
    onChange(option.value)
  }
  return (
    <Flex wrap="wrap" className="source-select" gap={16}>
      {options.map((option) => {
        return (
          <Flex
            key={option.value}
            component="button"
            type="button"
            className={cls("source-select-option", {
              active: value === option.value
            })}
            onClick={() => onOptionSelect(option)}
            align="center"
            justify="center"
            vertical
            gap={12}
          >
            <Flex className="source-option-icon-container" align="center" justify="center">
              <Icon className="source-option-icon" type={option.icon} />
            </Flex>
            <Text>{option.label}</Text>
          </Flex>
        )
      })}
    </Flex>
  )
}

export default SourceSelect
